import type Article from '@gik/blog/models/Article';
import { useBemCN } from '@gik/core/utils/bemBlock';
import type { ICarouselProps } from '@gik/ui/Carousel';
import { Carousel } from '@gik/ui/Carousel';
import { ArticleCarouselTile } from '@gik/ui/gik/ArticleTile';
import React from 'react';

export interface IArticlesCarouselProps {
  articles: Article[];
}

const blockName = 'articles-carousel';

export function ArticlesCarousel({ articles }: IArticlesCarouselProps) {
  const bem = useBemCN(blockName);

  const carouselSettings: ICarouselProps = {
    dots: true,
    fade: true,
    infinite: true,
    speed: 1500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 20000,
    pauseOnHover: true,
    pauseOnDotsHover: true,
    arrows: true,
    arrowButtonSize: 'lg',
    variant: 'primary',
    ...bem(),
  };

  return (
    <Carousel {...carouselSettings}>
      {articles?.map((article, key) => (
        <ArticleCarouselTile key={key} article={article} />
      ))}
    </Carousel>
  );
}
